import { ProgressBarFill, ProgressBarRoot } from './ProgressBar.styled';
import type { ProgressBarProps } from './ProgressBar.types';

export const ProgressBar = <T extends number | undefined>({
  max,
  value,
  styledComponents,
  time,
}: ProgressBarProps<T>) => {
  const percentage = ((value || 0) / (max || 0)) * 100 || 0;

  return (
    <ProgressBarRoot {...styledComponents?.root}>
      <ProgressBarFill percent={percentage} time={time} {...styledComponents?.fill} />
    </ProgressBarRoot>
  );
};
